import { useLocation } from "react-router-dom";

export const usePathName = (id?: number) => {
  const location = useLocation();

  const pageTitle: { [pathname: string]: string } = {
    "/MachineList": "機械一覧",
    "/MachineList/Register": "機械登録",
    "/MachineList/Dashboard": "ダッシュボード",
    "/UserProfile": "ユーザープロフィール",
    "/UserProfile/Modify": "ユーザープロフィール編集",
    "/UserManagement": "ユーザー管理",
    "/MachineList/Dashboard/TrendExpand": "トレンド拡大",
  };

  const getBasePath = (path: string, id?: number) => {
    if (id) {
      const pathWithId = `/MachineList/MachineModify/${id}`;
      const collectionDataSetPath = `/MachineList/CollectionDataSet/${id}`;

      if (path === pathWithId) {
        return pathWithId;
      }
      if (path === collectionDataSetPath) {
        return collectionDataSetPath;
      }
    }

    for (const key of Object.keys(pageTitle)) {
      if (path.startsWith(key)) {
        return key;
      }
    }
    return "";
  };

  const basePath = getBasePath(location.pathname, id);
  const title = basePath && pageTitle[basePath] ? pageTitle[basePath] : "ページタイトル";
  return title;
};
